import React from 'react'

function Boresha3() {
  return (
    <div>

<div className="my-4">
        <ul className="list-disc list-inside">
        <li>Premiums contributions will not be payable for the final two years of the policy.</li>
        <li>The premiums contributions are flexible and affordable. They are payable monthly, quarterly, semi-annually or annually.</li>
        <li>Premium contribution period is flexible between 6 and 18 years depending on the education needs of the child.</li>
        <li>The product has a medical or none medical underwriting option.</li>
        <li>The Plan allows for late age entry up to age 60; the maximum entry age for most education products is currently set at 55 years</li>

        </ul>
      </div>




    </div>
  )
}

export default Boresha3